import { resolveTooltipDisplayText } from "../../tooltips/tooltipRuntimeCache";

/** Renders tooltip title text; resolves DB overrides when TooltipProvider has loaded. */
export const tooltipComponent = (text: string) => {
  const display = resolveTooltipDisplayText(text);
  return (
    <h1
      style={{
        color: "white",
        fontSize: "20px",
        whiteSpace: "pre-wrap",
      }}
    >
      {display}
    </h1>
  );
};
